import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { isDemo, installDemo } from "./demo/install";
import "./index.css";

// Dark by default (admin console feel). Toggle on html root via future settings.
document.documentElement.classList.add("dark");

// Service worker — makes the PWA installable (manifest + active SW satisfies
// the install criteria) and serves the shell offline. The SW is at /sw.js
// and self-updates: a new bundle deploy bumps the index.html (no-cache),
// which then references new hashed /assets/*; the SW activate cycle cleans
// old caches. Failure is non-fatal — the app still runs as a plain SPA.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch((err) => console.warn("dyno SW registration failed:", err));
  });
}

if (isDemo()) {
  installDemo();
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
